// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","business":"_35uHg8TUcjom","descriptions":"_1JJnJco2GGeP","paper":"_1T1lMNTUVA6d"};